import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  fullWidth: {
    width: '100%',
  },
  dialogSubTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: 0,
  },
  iconUploadContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  iconUploadPreviewContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 15,
  },
  iconUploadButton: {
    paddingTop: '12px !important',
    paddingBottom: '10px !important',
  },
  multiselectTitle: {
    zIndex: 1000,
  },
  iconPreview: { maxWidth: 200, maxHeight: 50 },
  outlinedMultiSelect: {
    paddingTop: '10px',
    '& .dropdown-container': {
      border: 'none',
      position: 'relative',
      paddingTop: '6px',
      paddingBottom: '7px',
      '&:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
        transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        pointerEvents: 'none',
      },
      '&:hover:before': {
        borderBottom: '2px solid rgba(0, 0, 0, 0.87)',
      },
      '&:focus-within': {
        boxShadow: 'none !important',
      },
      '&:focus-within:before': {
        borderBottom: '2px solid rgba(0, 0, 0, 0.87)',
      },
    },
    '&.disabled': {
      opacity: 0.6,
      pointerEvents: 'none',
      '& .dropdown-container': {
        '&:before': {
          borderBottom: '1px solid rgba(0, 0, 0, 0.26)',
        },
        '&:hover:before': {
          borderBottom: '1px solid rgba(0, 0, 0, 0.26)',
        },
        '&:focus-within:before': {
          borderBottom: '1px solid rgba(0, 0, 0, 0.26)',
        },
      },
      '& .rmsc': {
        opacity: 0.6,
        '& .dropdown-heading': {
          color: 'rgba(0, 0, 0, 0.38)',
        },
        '& .dropdown-heading-value': {
          color: 'rgba(0, 0, 0, 0.38)',
        },
        '& .gray': {
          color: 'rgba(0, 0, 0, 0.38)',
        },
        '& .multi-select-container': {
          '& .item-renderer': {
            '& .item': {
              color: 'rgba(0, 0, 0, 0.38)',
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
            },
          },
        },
        '& .search': {
          color: 'rgba(0, 0, 0, 0.38)',
        },
      },
      '& span': {
        color: 'rgba(0, 0, 0, 0.38) !important',
      },
      '& .item': {
        color: 'rgba(0, 0, 0, 0.38) !important',
        backgroundColor: 'rgba(0, 0, 0, 0.05) !important',
      },
    },
  },
  impactMessage: {
    marginTop: 24,
    fontFamily: 'Arial',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '18.4px',
    letterSpacing: 0,
    backgroundColor: '#E8F4F2',
    padding: theme.spacing(2),
    borderRadius: 10,
    color: '#275E56',
    border: `1px solid #275E56`,
  },
  tootlTipUsers: {
    backgroundColor: '#27352E26',
    padding: '16px',
    borderRadius: '5px',
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Montserrat',
    lineHeight: '100%',
    letterSpacing: 0,
    minHeight: 60,
  },
  topCheckbox: { paddingBottom: 0, paddingTop: 0 },
}))

export { useStyles }
